// Centralized company contact configuration
export const COMPANY = {
  name: "Move On Packers & Movers",
  shortName: "Move On",
  tagline: "White-Glove Relocation in Kochi",
  phone: "+91 85903 57752",
  phoneRaw: "+918590357752",
  whatsapp: "918590357752",
  email: "houseshifterss@gmail.com",
  address: "MG Road, Ernakulam, Kochi, Kerala 682011",
  city: "Kochi",
  state: "Kerala",
  whatsappMessage: "Hello, I'd like to request a private consultation for my move.",
  instagram: "https://www.instagram.com/moveonshifters?igsh=NWtqZHRxaThtZDFp",
  facebook: "https://www.facebook.com/share/1LEjurvrmC/",
};

export const buildWhatsAppUrl = (message = COMPANY.whatsappMessage) =>
  `https://wa.me/${COMPANY.whatsapp}?text=${encodeURIComponent(message)}`;

export const callUrl = `tel:${COMPANY.phoneRaw}`;
export const mailUrl = `mailto:${COMPANY.email}`;
